<style scoped>
.contet_title {
  font-size: 22px;
  padding-top: 25px;
  padding-bottom: 20px;
  text-align: center;
  font-weight: bold;
}
.content--box {
  padding: 15px;
  box-sizing: border-box;
}
</style>

<template>
  <div>
    <div class="contet_title">
      {{ title }}
    </div>
    <div class="content--box">
      <div
        style="
          font-family: Consolas, 'Courier New', monospace;
          line-height: 19px;
        "
      >
        <div>1、设立美滋来外卖食品安全投诉举报处理中心 负责人:古莱姆拜尔·艾海提</div>
        <div>2、及时向商家传达网络食品销售管理制度</div>
        <div>3、及时接收顾客关于食品安全方面的投诉，并跟进处理</div>
        <div>
          4、对发生的食品安全突发事件依照《网络食品安全违法行为查处办法》进行实施
        </div>
        <div>5、对发生严重违法行为的商家将停止平台服务</div>
        <div>6、美滋来外卖食品安全投诉举报电话：400-1111-990</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
    };
  },
  created() {
    this.title = this.$route.query.data;
  },
  methods: {},
};
</script>
